import React from 'react';
import SavedFiltersDataTable from '../../../../../common/SavedFiltersDataTable/SavedFiltersDataTable';
import { ACTIONS } from '../../../../../../../consts/CommonV2';

export const QA_ID_PREFIX = 'SavedRecipientsContainer';

function SavedRecipientsContainer({ selectedFilter = null, onSelectionChange, onApply }) {
  return (
    <SavedFiltersDataTable
      mode={ACTIONS.CAMPAIGN_PAGE}
      selectedFilter={selectedFilter}
      onSelectionChange={onSelectionChange}
      onApply={onApply}
      searchPlaceholder="Search for contact lists"
      qaPrefix={QA_ID_PREFIX}
      itemsPerPageDefault={8}
      className="saved-recipients-container"
      data-testid={`${QA_ID_PREFIX}-data-table`}
    />
  );
}

export default SavedRecipientsContainer;
